import Resource from "./resource";
import { NamedResource, TenantedDeploymentMode, ActionTemplateParameterResource } from "client/resources";

export interface ProjectResource extends NamedResource {
    VariableSetId: string;
    DeploymentProcessId: string;
    DiscreteChannelRelease: boolean;
    IncludedLibraryVariableSetIds: string[];
    DefaultToSkipIfAlreadyInstalled: boolean;
    TenantedDeploymentMode: TenantedDeploymentMode;
    VersioningStrategy: VersioningStrategy;
    ReleaseCreationStrategy: ReleaseCreationStrategy;
    Templates: ActionTemplateParameterResource[];
    AutoDeployReleaseOverrides: any[];
    Slug: string;
    Description: string;
    IsDisabled: boolean;
    ProjectGroupId: string;
    LifecycleId: string;
    AutoCreateRelease: boolean;
    ProjectConnectivityPolicy: ProjectConnectivityPolicy;
    DefaultGuidedFailureMode: GuidedFailureMode;
    logo?: string;
}

export interface VersioningStrategy {
    DonorPackageStepId?: string;
    Template: string;
}

export interface ReleaseCreationStrategy {
    ReleaseCreationPackageStepId: string;
    ChannelId?: string;
}

export interface ProjectConnectivityPolicy {
    SkipMachineBehavior: string;
    TargetRoles: string[];
    AllowDeploymentsToNoTargets: boolean;
}

export enum GuidedFailureMode {
    EnvironmentDefault = "EnvironmentDefault",
    Off = "Off",
    On = "On"
}

export default ProjectResource;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/projectResource.ts